<div class="fechamento-page" data-tour="fechamento-tela">
  <div class="fechamento-toolbar">
    <div class="titulo-wrapper">
      <span class="icone-titulo"><i class="pi pi-wallet"></i></span>
      <div>
        <h2 class="titulo">
          @if ($ehAdministrador()) {
            {{ 'BARDO_FECHAMENTO.TITULO' | translate }}
          } @else {
            {{ 'BARDO_FECHAMENTO.MEU_FECHAMENTO' | translate }}
          }
        </h2>
        <p class="subtitulo">{{ $subtitulo() }}</p>
      </div>
    </div>

    <p-button
      type="button"
      icon="pi pi-print"
      [label]="'BARDO_FECHAMENTO.BOTAO_IMPRIMIR' | translate"
      styleClass="p-button-outlined"
      data-tour="fechamento-acao"
      [disabled]="loading() || $semResultados()"
      (click)="imprimir()"
    ></p-button>
  </div>

  <p-card styleClass="filtros-card">
    <div class="filtros-container" data-tour="fechamento-filtros">
      @if ($ehAdministrador()) {
        <div class="filtro-item">
          <label for="profissionalSelecionado">{{ 'BARDO_FECHAMENTO.FILTROS.PROFISSIONAL' | translate }}</label>
          @if (deviceService.$isMobile()) {
            <lib-n-multiselect
              [multiple]="false"
              [ngModel]="profissionalSelecionadoId"
              (ngModelChange)="profissionalSelecionadoId = $event; buscarRelatorio()"
              [options]="opcoesProfissional()"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'BARDO_FECHAMENTO.FILTROS.SELECIONE_PROFISSIONAL' | translate"
            />
          } @else {
            <p-select
              id="profissionalSelecionado"
              [(ngModel)]="profissionalSelecionadoId"
              [options]="opcoesProfissional()"
              optionLabel="label"
              optionValue="value"
              styleClass="w-full"
              (onChange)="buscarRelatorio()"
            />
          }
        </div>
      }

      <div class="filtro-item">
        <label for="dataInicio">{{ 'BARDO_FECHAMENTO.FILTROS.DATA_INICIO' | translate }}</label>
        <input
          id="dataInicio"
          type="date"
          pInputText
          [(ngModel)]="dataInicio"
          [max]="dataFim"
          (ngModelChange)="buscarRelatorio()"
          class="w-full"
        />
      </div>

      <div class="filtro-item">
        <label for="dataFim">{{ 'BARDO_FECHAMENTO.FILTROS.DATA_FIM' | translate }}</label>
        <input
          id="dataFim"
          type="date"
          pInputText
          [(ngModel)]="dataFim"
          [min]="dataInicio"
          (ngModelChange)="buscarRelatorio()"
          class="w-full"
        />
      </div>
    </div>
  </p-card>

  <p-card styleClass="resultado-card">
    @if (loading()) {
      <div class="loading-state">
        <i class="pi pi-spin pi-spinner"></i>
        <p>{{ 'BARDO_FECHAMENTO.ESTADOS.BUSCANDO' | translate }}</p>
      </div>
    } @else if ($semResultados()) {
      <div class="empty-state">
        <i class="pi pi-inbox"></i>
        <p>{{ 'BARDO_FECHAMENTO.ESTADOS.SEM_RESULTADOS' | translate }}</p>
      </div>
    } @else {
      @for (grupo of porProfissional(); track grupo.profissionalId) {
        @if (grupo.agendamentos.length) {
          <div class="grupo-profissional">
            @if ($ehAdministrador()) {
              <div class="grupo-header">
                <span class="nome">{{ grupo.profissionalNome }}</span>
                <span class="subtotal">{{ grupo.total | moeda }}</span>
              </div>
            }

            @for (agendamento of grupo.agendamentos; track agendamento.servicoId + $index) {
              <div class="servico-item">
                <div class="data-hora">
                  <span class="data">{{ agendamento.dataHora | date:'dd/MM/yyyy' }}</span>
                  <span class="hora">{{ agendamento.dataHora | date:'HH:mm' }}</span>
                </div>
                <div class="servico-detalhe">
                  <span class="nome">{{ agendamento.servicoNome }}</span>
                </div>
                <div class="valor">
                  <span>{{ agendamento.valor | moeda }}</span>
                </div>
              </div>
            }
          </div>
        }
      }
    }
  </p-card>

  <div class="total-summary">
    <span class="label">{{ 'BARDO_FECHAMENTO.TOTAL_PERIODO' | translate }}</span>
    <span class="valor">{{ totalGeral() | moeda }}</span>
  </div>
</div>
